export enum LessonType {
    VR = 0,
    GAME = 1,
}
